<template>
  <div class="card-subtitle">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.card-subtitle {
  color: $shades_grey-dark;
  text-align: center;
  font-family: $family-lexend;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
